export default __webpack_public_path__ + "static/media/portable-speaker-2.10b1203d.png";